import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/feed')({
  component: FeedLayout,
});

function FeedLayout() {
  return <Outlet />;
}

